import { ServiceNotificationsState } from '@typings/serviceNotifications'

// As of 2025-02-02 we are using hardcoded data until a backend is available.
// On 2026-02-05 between 1100 and 1230 there will be an impactful outage.
// If this time has passed this code hardcoded notification can be safely deleted.
export const initialState: ServiceNotificationsState = {
  serviceNotifications: [
    {
      activeWindow: {
        startTs: 1770285600000,
        endTs: 1770296400000,
      },
      content: {
        severity: 'warning',
        title: {
          en: 'Scheduled Maintenance',
          sv: 'Planerat underhåll',
          fi: 'Suunniteltu huolto',
          no: 'Planlagt vedlikehold',
        },
        description: {
          en: 'System is undergoing maintenance. Some features may be unavailable.',
          sv: 'Systemet genomgår underhåll. Vissa funktioner kan vara otillgängliga.',
          fi: 'Järjestelmässä tehdään huoltotöitä. Osa toiminnoista saattaa olla poissa käytöstä.',
          no: 'Systemet gjennomgår vedlikehold. Noen funksjoner kan være utilgjengelige.',
        },
      },
    },
  ],
}

const serviceNotificationReducer = (state = initialState) => {
  return state
}
export default serviceNotificationReducer
